var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWlkn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FBB935",
    fillRule: "evenodd",
    d: "M12 18a6 6 0 1 0 0-12a6 6 0 0 0 0 12m0 1.286a7.286 7.286 0 1 0 0-14.572a7.286 7.286 0 0 0 0 14.572",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB830",
    d: "M8.785 11.109c-.343 0-.57.308-.643.463v2.357c0 .857.858 1.928 2.143 1.928c1.029 0 1.5-.428 1.715-.857c.214.429.998.857 1.5.857c1.5 0 2.357-1.071 2.357-1.813V9.887c0-.15-.129-.458-.643-.458s-.643.308-.643.463v3.822c0 .309-.214.857-1.071.857c-.858 0-.858-.548-.858-.857V10.75c0-.155-.128-.463-.642-.463c-.515 0-.643.308-.643.463v2.965c0 .309-.386.857-1.072.857c-.685 0-.857-.548-.857-.857v-2.142c0-.232-.214-.463-.643-.463"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlkn);
export default __webpack_public_path__ + "static/media/wlkn.c87389c25e8e59ba009719ccc72b32ae.svg";
export { ForwardRef as ReactComponent };